import { request_list } from '@/commons/hpod';
import Vue from 'vue';
import Crud from './crud'
var crud = new Crud('report-money-yuan', 'báo cáo thu chi RMB');

const state = {
    ...crud.state,
    all: {
        data: []
    },
    summary: {
        summary: [],
        last_time: []
    }
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
    getSummary({ commit }, param) {
        request_list('report-money-yuan/summary', data => {
            commit('setSummary', data);
        }, Vue.http, param, this.state.authentication.token);
    },
};
const mutations = {
    ...crud.mutations,
    setSummary(state, ret) {
        state.summary = ret.data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};